module.exports = __webpack_public_path__ + "img/Ticimax.b5d01ca2.png";